import React from 'react';

import { View, Platform, StyleSheet } from 'react-native';
import { THEME, FONT } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeCurrentCase } from './actions';
import { setCalendarViewEmployer } from '../calendar/actions';
import { shouldShowAllResidentsInCal } from '../calendar/selector';
import { getSortedCasesArray } from '../../selectors/entities';

import { OPComponent, Navigation, SuggestionList, NavBar, Utils, I18n } from '../components';

class SelectCase extends OPComponent {
  static options(passProps) {
    return {
      topBar: {
        leftButtons: [NavBar.buttons.done],
      },
    };
  }

  constructor(props) {
    super(props);

    const initialItems = [];
    if (props.includeEmployerSelection) {
      initialItems.push({
        label: I18n.aec('allResidents'),
        id: -1,
        extraLabelStyle: styles.residentsLabel,
      });
    }

    this.state = {
      items: initialItems.concat(
        props.cases.map(caseItem => {
          return { label: caseItem.name, id: caseItem.caseId };
        })
      ),
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    const { componentId } = this.props;

    if (NavBar.handleButtonPress(componentId, buttonId)) return;
  };

  componentDidMount() {
    Utils.trackScreen('Cases', 'Select Cases');
    Navigation.registerForButtonEvents(this);
  }

  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
  }

  handleSelect = ({ value, item }) => {
    if (!item) return;
    const caseId = item.id;
    Utils.trackEvent('Action', 'Set', 'Selected Case', caseId);
    if (caseId < 0) {
      this.props.actions.setCalendarViewEmployer(true);
    } else {
      if (this.props.includeEmployerSelection) {
        this.props.actions.setCalendarViewEmployer(false);
      }
      this.props.actions.changeCurrentCase(caseId);
    }
    Navigation.close(this.props);
  };

  render() {
    const props = this.props;
    const selectedId =
      props.includeEmployerSelection && props.showAllResidents ? -1 : this.props.currentCaseId;
    return (
      <View style={styles.container}>
        <SuggestionList
          items={this.state.items}
          selectedId={selectedId}
          defaultValue={null}
          onValue={this.handleSelect}
          placeholderText={I18n.ac('search')}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  caseRow: {
    padding: 25,
  },
  residentsLabel: {
    ...FONT.semibold,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    cases: getSortedCasesArray(state),
    currentCaseId: state.application.currentCaseId,
    showAllResidents: shouldShowAllResidentsInCal(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ changeCurrentCase, setCalendarViewEmployer }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCase);
